import{useState} from 'react';
import axios from 'axios';

const API_KEY = 'b0c277718998802d0e2418f8ad71c637'; // Replace with your actual API key
export const useWeather = () => {
    const [data,setData]=useState(null);
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(null);
     const fetchWeather=async(city)=>{
        setLoading(true);
        setError(null);
        try{
            const url=`https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${API_KEY}`
            const response=await axios.get(url);
            setData(response.data);
        }catch(err){
            setError(err.response?.status===404?'City not found':'An error occurred while fetching weather data');
            setData(null);
        }finally{
            setLoading(false);
        }
};
    return{data,loading,error,fetchWeather};
};